import { Fragment } from 'react';
import { Provider } from 'react-redux';

import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { TuningShopGlobalStyles } from './GlobalStyles';
import { store } from './redux/store';
import { TechTuning } from './views/TechTuning';

const LayoutComponent = () => (
	<Provider store={store}>
		<Fragment>
			<TuningShopGlobalStyles />
			<Background />
			<TechTuning />
		</Fragment>
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.TechTuning)
	.build();

export default Layout;
